import React from "react";
import { LabeledText, getFileInfo, LabeledDate, LabeledScrollableText } from "sprint-common-web";

import { DeliveryType } from "../../../types/DeliveryType";
import { formatBytes } from "../../../utils/formatBytes";
import { UploadDeliveryItem } from "../DeliveryItem";

export interface UploadDeliveryInfoAsideContentProps {
    delivery: UploadDeliveryItem;
}

export const UploadDeliveryInfoAsideContent: React.FunctionComponent<UploadDeliveryInfoAsideContentProps> = (
    props: UploadDeliveryInfoAsideContentProps
) => {
    const { delivery } = props;

    const fileSize = delivery.file.size ? formatBytes(delivery.file.size) : undefined;
    const { name: fileName, extension: fileExtension } = getFileInfo(delivery.file.path);

    return (
        <>
            <LabeledText label="Delivery type" value={DeliveryType[delivery.type]} />
            <LabeledText label="File name" value={`${fileName}.${fileExtension}`} textTooltip={true} />
            <LabeledText label="File size" value={fileSize} />
            <LabeledDate label="Arrival date" value={new Date(delivery.file.arrivalDate)} />
            <LabeledText label="Name" value={delivery.sender?.name} textTooltip={true} />
            <LabeledText label="Email" value={delivery.sender?.email} textTooltip={true} />
            <LabeledText label="Subject" value={delivery.sender?.subject} textTooltip={true} />
            <LabeledScrollableText
                height={delivery.sender.message?.length ? 100 : 20}
                label="Message"
                value={delivery.sender?.message || "-"}
            />
            <LabeledText label="Originator id" value={delivery.originator?.id} textTooltip={true} />
            <LabeledText label="Originator name" value={delivery.originator?.name} textTooltip={true} />
        </>
    );
};
